import { useSelector } from 'react-redux';
import { IRootState } from '@state/reducers/Reducers';
import { PageName } from '@utils/pageConfig/Types';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';

const MULTI_PRODUCT_GROUP_PAGES: PageName[] = [
  PageName.RETAILER_OVERVIEW,
  PageName.CATEGORY_LEADERBOARD,
  PageName.EXPLORE,
  PageName.OPPORTUNITY_REVIEW,
];

export const useGetLoadedProductGroups = () => {
  const { totalAvailablePgs, totalSubscriptionPgs } = useSelector((state: IRootState) => state.availabilityPg);
  const { pageName } = usePageConfig();

  const loadedProductGroups = MULTI_PRODUCT_GROUP_PAGES.includes(pageName)
    ? {
        loadedProductGroups: {
          totalAvailablePgs,
          totalSubscriptionPgs,
        },
      }
    : {};

  return {
    loadedProductGroups,
  };
};
